import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cart-item mb-2 px-2 pt-1 pb-0 border-secondary border rounded" }
const _hoisted_2 = { class: "cart-top-row" }
const _hoisted_3 = { class: "cart-bot-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Celkem:", -1)

import { CartProduct, useCartStore } from '@/store/CartStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartProductItem',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
    product: CartProduct
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(__props.product.name), 1),
      _createElementVNode("p", null, _toDisplayString(__props.product.price.toFixed(2)) + " Kč", 1),
      _createElementVNode("p", null, _toDisplayString(__props.product.amount) + "x", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", null, _toDisplayString((__props.product.price * __props.product.amount).toFixed(2)) + " Kč", 1)
    ])
  ]))
}
}

})